/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MeetingParticipant
 */
export interface MeetingParticipant {
  /**
   *
   * @type {string}
   * @memberof MeetingParticipant
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof MeetingParticipant
   */
  email?: string | null;
}

/**
 * Check if a given object implements the MeetingParticipant interface.
 */
export function instanceOfMeetingParticipant(
  value: object,
): value is MeetingParticipant {
  return true;
}

export function MeetingParticipantFromJSON(json: any): MeetingParticipant {
  return MeetingParticipantFromJSONTyped(json, false);
}

export function MeetingParticipantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MeetingParticipant {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    email: json["email"] == null ? undefined : json["email"],
  };
}

export function MeetingParticipantToJSON(json: any): MeetingParticipant {
  return MeetingParticipantToJSONTyped(json, false);
}

export function MeetingParticipantToJSONTyped(
  value?: MeetingParticipant | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    email: value["email"],
  };
}
